import React from "react";
import { Card, CardBody } from "reactstrap";
import { Colxx } from "/@src/components/common/CustomBootstrap";
import IntlMessages from "/@src/helpers/IntlMessages";

const FeatureComparison = ({ data }) => {
  const { allPlans, features } = data;
  return (
    <>
      {/* Larger screen layout */}
      <Colxx xxs="12" className="d-md-block overflow-auto">
        <div style={{ minWidth: "1000px" }}>
          <Card className="mb-3 table-heading">
            <div className="d-flex flex-grow-1 min-width-zero">
              <CardBody className="align-self-center d-flex justify-content-between min-width-zero align-items-center">
                <p className="list-item-heading mb-0 truncate w-40 " />
                {allPlans.map((p, i) => {
                  return (
                    <p className="mb-0 text-primary w-20 text-center" key={i}>
                      {/* <IntlMessages id="pages.price.developer" /> */}
                      {p.name}
                    </p>
                  );
                })}
              </CardBody>
            </div>
          </Card>
          {features.map((f, i) => {
            return (
              <Card className="flex flex-row mb-3" key={i}>
                <div className="d-flex flex-grow-1 min-width-zero">
                  <CardBody className="align-self-center d-flex justify-content-between min-width-zero align-items-md-center">
                    <p className="list-item-heading mb-0 truncate w-40 ">
                      {/* <IntlMessages id="pages.price.twofactorauthentication" /> */}
                      {f.feature.name}
                    </p>
                    {allPlans.map((p, i) => {
                      return f.plans.includes(p.name) ? (
                        <p
                          className="mb-0 text-primary w-20 text-center"
                          key={i}
                        >
                          <i className="simple-icon-check" />
                        </p>
                      ) : (
                        <p
                          key={i}
                          className="mb-0 text-primary w-20 text-center"
                        />
                      );
                    })}
                  </CardBody>
                </div>
              </Card>
            );
          })}
        </div>
      </Colxx>
    </>
  );
};

export default FeatureComparison;
